module.exports = __webpack_public_path__ + "img/yj1.45bcba2b.png";